import script from "./MessageTip.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageTip.vue?vue&type=script&setup=true&lang=js"

import "./MessageTip.vue?vue&type=style&index=0&id=fcaf9a78&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcaf9a78"]])

export default __exports__